import { Component, OnInit, ViewEncapsulation, forwardRef, ElementRef, Renderer, Injector } from '@angular/core';
import { ToggleOption, BaseAbstractControl } from 'moh-package';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, FormGroup, FormControl, ValidatorFn } from '@angular/forms';

@Component({
  selector: 'moh-clm-claimer',
  templateUrl: './clm-claimer.component.html',
  styleUrls: ['./clm-claimer.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => ClmClaimerComponent), multi: true, },
    { provide: NG_VALIDATORS, multi: true, useExisting: forwardRef(() => ClmClaimerComponent) }]
})
export class ClmClaimerComponent extends BaseAbstractControl implements OnInit {
  FamilyStatusList: any[] = [
    { Id: 1, Name: 'נשוי' },
    { Id: 2, Name: 'רווק' },
    { Id: 4, Name: 'תל אביבי' }
  ];
  GenderSlideToggleOptions: ToggleOption[];
  cityValidators: ValidatorFn[] = [];
  streetValidators: ValidatorFn[] = [];
  houseNumberValidators: ValidatorFn[] = [];
  entranceValidators: ValidatorFn[] = [];
  appartmentValidators: ValidatorFn[] = [];
  zipCodeValidators: ValidatorFn[] = [];
  postboxValidators: ValidatorFn[] = [];

  constructor(injector: Injector) {

    super(injector);
  }

  ngOnInit() {

    this.GenderSlideToggleOptions = [new ToggleOption('זכר', true), new ToggleOption('נקבה', false)];

    this.initializeFormGroup();

    //this.slideToggleOptions = [new ToggleOption('כן', true), new ToggleOption('לא', false)];

    super.ngOnInit();
  }

  initializeFormGroup() {

    this.baseAbstractControl = new FormGroup({
      FirstName: new FormControl('', []),
      LastName: new FormControl('', []),
      IDNumber: new FormControl('', []),
      DateOfBirth: new FormControl('', []),
      Gender: new FormControl(false, []),
      DateOfImmigratio: new FormControl('', []),
      FamilyStatus: new FormControl('', []),
      WifeName: new FormControl('', []),
      WifeIDNumber: new FormControl('', []),
      //Additional info
      BirthCountry: new FormControl('', []),
      DateOfImmigration: new FormControl('', []),
      FathersName: new FormControl('', []),
      FatherBirthCountry: new FormControl('', []),
      FatherPrevFirstName: new FormControl('', []),
      FatherPrevLastName: new FormControl('', []),
      Address: new FormControl('', []),
      //Contact Info
      PhoneNumber: new FormControl('', []),
      MobileNumber: new FormControl('', []),
      FaxNumber: new FormControl('', []),
      AgreeReceiveSMS: new FormControl('', []),
      Email: new FormControl('', []),
      //Another contact
      ContanctCloserToCaimer: new FormControl('', []),
      ContanctFirstName: new FormControl('', []),
      ContanctLastName: new FormControl('', []),
      ContanctPhoneNumber: new FormControl('', []),
      ContanctMobileNumber: new FormControl('', []),
      BankAccountDetails: new FormControl('', [])
    });
  }
}



// WEBPACK FOOTER //
// E:/Develop/MOH.Gazezet/Dev/MOH.Gazzezet/MOH.Gazzezet/src/app/components/claim/clm-claimer/clm-claimer.component.ts